import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CopyField, PageHeader, Panel, RowsSkeleton } from "@/components/app/kit";
import { TenantForm, emptyTenant } from "@/components/platform/TenantForm";
import { useFetch } from "@/hooks/useServerList";
import { api } from "@/lib/api";

export const InviteNotice = ({ url, email }) => (
  <div className="rounded-xl border border-sky-200 bg-sky-50 p-4 space-y-3" data-testid="invite-notice">
    <p className="text-sm text-sky-900">
      Lien d'invitation sécurisé pour <strong>{email}</strong> (valable 7 jours). Aucun service d'e-mail n'étant configuré, transmettez-le manuellement — il est aussi consigné dans le journal d'envoi.
    </p>
    <CopyField value={url} testid="invite-link" />
  </div>
);

export default function TenantNew() {
  const ref = useFetch("/platform/reference");
  const [created, setCreated] = useState(null);

  if (created)
    return (
      <div className="max-w-2xl">
        <PageHeader eyebrow="Cabinet créé" title={created.tenant.name} />
        <Panel testid="tenant-created-panel">
          <div className="flex items-center gap-3 mb-5 text-emerald-700"><CheckCircle2 className="h-6 w-6" /><p className="font-semibold">Espace cabinet généré : rôles, modules, domaines et paramètres initiaux.</p></div>
          {created.invite_url ? <InviteNotice url={created.invite_url} email={created.tenant.admin_contact.email} /> : (
            <p className="text-sm text-slate-600" data-testid="admin-already-active">L'administrateur possède déjà un compte actif : il a été rattaché directement au cabinet.</p>
          )}
          <div className="flex gap-3 mt-6">
            <Button asChild data-testid="go-to-tenant"><Link to={`/admin/cabinets/${created.tenant.id}`}>Voir le cabinet <ArrowRight className="h-4 w-4 ml-2" /></Link></Button>
            <Button variant="outline" onClick={() => setCreated(null)} data-testid="create-another">Créer un autre cabinet</Button>
          </div>
        </Panel>
      </div>
    );

  return (
    <div>
      <PageHeader eyebrow="Cabinets médicaux" title="Nouveau cabinet" subtitle="L'administrateur recevra une invitation sécurisée pour définir lui-même son mot de passe." />
      {ref.loading || !ref.data ? <RowsSkeleton rows={8} /> : (
        <TenantForm reference={ref.data} initial={emptyTenant(ref.data)} mode="create"
          onSubmit={async (payload) => setCreated((await api.post("/platform/tenants", payload)).data)} />
      )}
    </div>
  );
}
